export default __webpack_public_path__ + "static/media/7.a4f1b9bc.png";